import { v4 as uuidv4 } from 'uuid';

import { getLocalStorageContext } from 'utils/localStorage/localStorageHelper';

const CORRELATION_ID_KEY = 'susi_correlation_id';

const localStorageContext = getLocalStorageContext('event-sender');

// Exported for testing purposes
export default function getSptCookie() {
  if (typeof window === 'undefined' || !document) {
    return '';
  }
  // sp_t cookie is used as it persisted for a year across all spotify domains.
  // https://backstage.spotify.net/docs/default/component/www-concierge/enrichers/cookies/#analytics-tracking-cookie-sp_t
  const cookieValue = document.cookie.match(/sp_t=([a-f\d-]+)/)?.[1];

  if (cookieValue) {
    return cookieValue;
  }

  // Fallback if cookie is not present or the client has disabled cookies or invalid UUID
  const storedValue = localStorageContext.getValue(CORRELATION_ID_KEY);
  if (storedValue) {
    return storedValue;
  }

  const uuid = uuidv4();
  localStorageContext.setValue(CORRELATION_ID_KEY, uuid);
  return uuid;
}
